import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "badge bg-info" }
const _hoisted_2 = { class: "fas fa-bolt" }

import { EChargingSpeedType } from '@/enums';
import { computed } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'ChargeSpeedIcon',
  props: {
    speedType: {}
  },
  setup(__props: any) {

const props = __props

const qtd = computed(() => {
    if (props.speedType == EChargingSpeedType.fast) return 2
    if (props.speedType == EChargingSpeedType.ultra) return 3
    return 1
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qtd.value, (_) => {
      return (_openBlock(), _createElementBlock("span", _hoisted_2))
    }), 256))
  ]))
}
}

})